import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/pos_change';

/** 状況 `pos_change_spell`（組み立ては `../fx/pos_change.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'pos_change_spell', role: 'effect', ...spec }, 'pos_change_spell_effect.js');
